import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC007_Request,
  IAPI_ACC007_Response,
  IAPI_ACC008_Request,
  IAPI_ACC008_Response,
} from "../../../type/apiType";

// パスワード再発行トークン認証
const httpAPI_ACC007 = async (
  param: IAPI_ACC007_Request
): Promise<IAPI_ACC007_Response> => {
  let res = await http.post(ApiUrl.API_ACC007, {
    ...param,
  });

  return res.data;
};

// パスワード変更
const httpAPI_ACC008 = async (
  param: IAPI_ACC008_Request
): Promise<IAPI_ACC008_Response> => {
  let res = await http.post(ApiUrl.API_ACC008, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC007, httpAPI_ACC008 };
